import { writable } from 'svelte/store';

export const userStore = writable({ 
    loggedIn: false,
    email: "",
    username: "로그인",
    organization: ""
});
// export const userProfile = get(userStore);